import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { VesselSpecStore } from '@navstation-portal/vessels/data-access/store';
import { FuelSpecsNonBdnComponent } from './fuel-specs-non-bdn/fuel-specs-non-bdn.component';

@Component({
  selector: 're-fuel-specs',
  templateUrl: './fuel-specs.component.html',
  imports: [FormsModule, FuelSpecsNonBdnComponent],
})
export class FuelSpecsComponent {
  vesselSpecStore = inject(VesselSpecStore);
}
